import { useAuth0 } from '@auth0/auth0-react';
import { useBackoffice } from '../../backoffice/useBackoffice';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export const useDownloadFile = (customerId: string, bucketFileKey: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const { developerId, isBackofficeOn } = useBackoffice();

  const query = useQuery({
    queryKey: ['file', developerId, customerId, bucketFileKey],
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/customers/${customerId}/file`, {
        params: {
          consumerId: developerId,
          bucketFileKey,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return {
        base64FileData: res.data,
        contentType: res.headers['content-type'] || 'application/octet-stream',
      };
    },
    refetchOnWindowFocus: false,

    enabled: isBackofficeOn && !!customerId,
  });

  return query;
};
